import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { BsFacebook } from "react-icons/bs";
import { BiLogoWhatsappSquare } from "react-icons/bi";
import api from "../../utils/axios.config";
import { baseUrl } from "../../utils/url";

const Member = () => {
  const [members, setMembers] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);

  const [allMember, setAllMember] = useState([]);

  const handleGetMember = async () => {
    const { data } = await api.get("member");

    if (data.success) {
      setMembers(data.data);
    }
  };

  useEffect(() => {
    handleGetMember();
  }, []);

  useEffect(() => {
    const totalPage = Math.ceil(members.length / 10);
    if (totalPage > currentPage) {
      setAllMember(members.slice(currentPage * 10, 10 * (currentPage + 1)));
    } else {
      setCurrentPage(0);
    }
  }, [currentPage, members]);

  const handleIncreasePage = () => {
    setCurrentPage(currentPage + 1);
  };
  const handleDecreasePage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="m-2 md:m-5">
      <h3 className="text-center font-bold text-2xl">কার্যকরী মন্ডলীর সদস্য</h3>
      <div className="my-2 flex justify-end">
        <input
          type="text"
          placeholder="মোবাইল নাম্বার লিখুন"
          class="input input-bordered input-md w-full max-w-xs"
        />
        <button className="btn bg-secondary text-white border-0 mx-2">
          অনুসন্ধান
        </button>
      </div>
      <div class="overflow-x-auto">
        <table class="table table-compact w-full">
          <thead>
            <tr>
              <th className="bg-secondary text-white">নাম এবং পদবী</th>
              <th className="bg-secondary text-white">
                কর্মরত প্রতিষ্ঠানের নাম এবং পদবী
              </th>
              <th className="bg-secondary text-white">যোগাযোগ</th>
              <th className="bg-secondary text-white">ঠিকানা</th>
              <th className="bg-secondary text-white">Social Media</th>
            </tr>
          </thead>
          <tbody>
            {allMember?.map((member, index) => (
              <tr key={index}>
                <div class="flex items-center space-x-3">
                  <div class="avatar">
                    <div class="mask mask-squircle w-24 h-24">
                      <img
                        src={`${baseUrl}${member.imageUrl}`}
                        alt="Avatar Tailwind CSS Component"
                      />
                    </div>
                  </div>
                  <div>
                    <div class="font-bold">{member?.name}</div>
                    <div class="text-sm opacity-80">
                      {member?.organizationDesignation}
                    </div>
                  </div>
                </div>

                <td>
                  <div class="font-bold">{member?.institute}</div>
                  <div class="text-sm opacity-80">{member?.designation}</div>
                </td>
                <td>
                  <div class="font-bold">{member?.mobile}</div>
                  <div class="text-sm opacity-80">{member?.email}</div>
                </td>
                <td>{member?.address}</td>
                <td className="flex items-center">
                  {member?.facebookUrl && (
                    <a
                      href={member?.facebookUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <BsFacebook color="blue" size={30} />
                    </a>
                  )}
                  {member?.whatsappUrl && (
                    <a
                      href={member?.whatsappUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <BiLogoWhatsappSquare color="green" size={35} />
                    </a>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="px-5">
          <div className="flex justify-end items-center">
            <div className="px-6 py-4">
              {currentPage * 10 + 1}-{10 * (currentPage + 1)} of{" "}
              {members?.length}
            </div>
            <div>
              <div className="flex items-center">
                <button className="pr-10" onClick={handleDecreasePage}>
                  <MdOutlineKeyboardArrowLeft />
                </button>
                <button onClick={handleIncreasePage}>
                  <MdOutlineKeyboardArrowRight />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Member;
